import React, { useState, useEffect } from 'react';
import { register } from '../../utils/auth';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';

function Register() {
    const [fullname, setFullname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn()) {
            navigate('/');
        }
    }, [isLoggedIn, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (password !== password2) {
            alert("Las contraseñas no coinciden.");
            setIsLoading(false);
            return;
        }

        const { error } = await register(fullname, email, phone, password, password2);
        if (error) {
            alert(JSON.stringify(error));
        } else {
            navigate('/');
        }
        setIsLoading(false);
    };

    return (
        <main className="" style={{ marginBottom: 100, marginTop: 50 }}>
            <div className="container">
                <section className="">
                    <div className="row d-flex justify-content-center">
                        <div className="col-xl-5 col-md-8">
                            <div className="card rounded-5">
                                <div className="card-body p-4">
                                    <h3 className="text-center">Crear Cuenta</h3>
                                    <br />
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="pills-login" role="tabpanel" aria-labelledby="tab-login">
                                            <form onSubmit={handleSubmit}>
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="full_name">
                                                        Nombre Completo
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="full_name"
                                                        placeholder="Nombre Completo"
                                                        required
                                                        className="form-control"
                                                        onChange={(e) => setFullname(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="email">
                                                        Correo Electrónico
                                                    </label>
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        placeholder="Dirección de Correo Electrónico"
                                                        required
                                                        className="form-control"
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="phone">
                                                        Número de Teléfono
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="phone"
                                                        placeholder="Número de Teléfono"
                                                        required
                                                        className="form-control"
                                                        onChange={(e) => setPhone(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="password">
                                                        Contraseña
                                                    </label>
                                                    <input
                                                        type="password"
                                                        id="password"
                                                        placeholder="Contraseña"
                                                        required
                                                        className="form-control"
                                                        onChange={(e) => setPassword(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="password2">
                                                        Confirmar Contraseña
                                                    </label>
                                                    <input
                                                        type="password"
                                                        id="confirm-password"
                                                        placeholder="Confirmar Contraseña"
                                                        required
                                                        className="form-control"
                                                        onChange={(e) => setPassword2(e.target.value)}
                                                    />
                                                </div>
                                                {isLoading ? (
                                                    <button className='btn btn-primary w-100' type="submit">
                                                        <span className="mr-2">Procesando</span>
                                                        <i className="fas fa-spinner fa-spin" />
                                                    </button>
                                                ) : (
                                                    <button className='btn btn-primary w-100' type="submit">
                                                        <span className="mr-2">Registrarse</span>
                                                        <i className="fas fa-user-plus" />
                                                    </button>
                                                )}
                                                <div className="text-center">
                                                    <p className='mt-4'>
                                                        ¿Ya tienes una cuenta? <Link to="/login/">Iniciar Sesión</Link>
                                                    </p>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
}

export default Register;
